module.exports = __webpack_public_path__ + "media/images/accountSection__settingsClose-6a395f46d80650a9586b9e45651268d7.png";